<template>
    <div class="container mx-auto mx-md-4 py-4" style="font-size: 1.5rem;">
        <header class="mb-4">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <img src="/images/logo.png" width="280px" alt="">
                    </div>
                    <div class="col d-inline-flex align-items-center justify-content-center" style="font-size: 1.5rem;">
                        {{ interactiveInterface.title }}
                    </div>
                    <div class="col d-inline-flex align-items-center justify-content-end" style="font-size: 1.5rem;" v-if="gameUser.fingerprint">
                        <div>{{ gameUser.nickname }}</div>
                    </div>
                </div>
            </div>
        </header>

        <div
            v-if="!isFinished"
        >
            <component
                v-if="currentTask"
                :is="currentTask.component_name"
                :task="currentTask"
                :userTask="userTask"
            />

            <div class="row mt-4">
                <div class="col-12">
                    <div class="w-100 d-inline-flex align-items-center justify-content-end">
                        <div class="mr-4">
                            {{ currentIndex + 1 }} / {{ interactiveInterface.tasks.length }}
                        </div>
                        <button
                            type="button"
                            class="btn btn-primary mr-2"
                            v-if="currentIndex > 0"
                            @click.prevent="prevTask"
                        >
                            Előző feladat
                        </button>
                        <button
                            v-if="hasNextTask()"
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="nextTask"
                        >
                            Következő feladat
                        </button>
                        <button
                            v-else
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="isFinished = true"
                        >
                            Befejezés
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-12 text-center">
                    <h2>Sikeresen végig nézte az eredményeket!</h2>
                    <p>Köszönjük a résztvételét!</p>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import {find} from "lodash";
import "./CheckTasks/TaskAnswerSelector.vue";

export default {
    data() {
        return {
            interactiveInterface: {},
            gameUser: {},
            currentIndex: 0,
            currentTask: null,
            userTask: null,
            isFinished: false,
        }
    },
    methods: {
        nextTask() {
            if (!this.hasNextTask()) {
                return;
            }

            this.currentIndex++;
            this.currentTask = this.interactiveInterface.tasks[this.currentIndex];
            this.userTask = find(this.gameUser.game_tasks, {'task_id': this.currentTask.id});
        },
        prevTask() {
            this.currentIndex--;
            this.currentTask = this.interactiveInterface.tasks[this.currentIndex];
            this.userTask = find(this.gameUser.game_tasks, {'task_id': this.currentTask.id});
        },
        hasNextTask() {
            return this.currentIndex + 1 < this.interactiveInterface.tasks.length
        }
    },
    created() {
        this.interactiveInterface = window.InteractiveInterface;
        this.currentTask = this.interactiveInterface.tasks[this.currentIndex];
        this.gameUser = window.gameUser;
        this.userTask = find(this.gameUser.game_tasks, {'task_id': this.currentTask.id});
    }
}
</script>
